import { development, test } from "./environments";

const macs365Development = 'http://localhost:8081';
const macs365test = 'https://macs365.test01.hgs.cloud';
const macs365Production = 'https://www.macs365.com';

const hgsKeyDevelopment = 'http://localhost:4002';
const hgsKeyTest = 'https://hgskey.test.hella-gutmann.cloud';
const hgsKeyProduction = 'https://accounts.hella-gutmann.com';


export const macs365Uri = development ? macs365Development : test ? macs365test: macs365Production;

export const hgsKeyBackendUri = development || test ? hgsKeyTest : hgsKeyProduction;

